import $http from "@/plugins/axios";
const AgentQuickResponseService = {
    create(botCode, title, content, type, skillGroup) {
        return $http.post(`/live-support/agent-quick-response/${botCode}`, {title, content, type, skillGroup});
    },
    findAll(botCode, isCommon=false) {
        return $http.get(`/live-support/agent-quick-response/${botCode}?isCommon=${isCommon}`)
    },
    findById(botCode, id) {
        return $http.get(`/live-support/agent-quick-response/${botCode}/${id}`)
    },
    update(botCode, id, title, content, type, skillGroup) {
        return $http.put(`/live-support/agent-quick-response/${botCode}/${id}`, {title, content, type, skillGroup})
    },
    deleteOne(botCode, id) {
        return $http.delete(`/live-support/agent-quick-response/${botCode}/${id}`);
    },
    export(botCode, data, isCommon=false) {
        return $http.post(`/live-support/agent-quick-response/export/${botCode}?isCommon=${isCommon}`, data)
    },
    uploadFile(botCode, file, type) {
        let formData = new FormData();
        formData.append('file', file);
        return $http.post(`/live-support/agent-quick-response/import_excel/${botCode}?type=${type}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    onUseTemplate(botCode, id, senderId, channel) {
        return $http.put(`/live-support/agent-quick-response/onUseTemplate/${botCode}/${id}`, {
            sender_id: senderId,
            channel: channel
        })
    }
}

export default AgentQuickResponseService;
